import { EntityBase } from "projects/sepidz-web-framework/src/lib/models/entity-base.model";
import { CategoryPopupState, ItemDependency, StockInWebKind } from "../../catalog/model/item.model";

export class OrderItemCategory extends EntityBase {
  public Title: string;
  public Color: string;
  public ApplyTax?: boolean;
  public ApplyService?: boolean;
  public PrintDisplayOrder: number;
  public ParentId?: number;
  public TaxApplyTypeId?: number;
  public TaxApplyTypeTitle: string;
  public TaxApplyTypeCode?: number;
  public ServiceApplyTypeId?: number;
  public ServiceApplyTypeTitle: string;
  public ServiceApplyTypeCode?: number;
  public StockInWeb: StockInWebKind;
  public ProtelCode: boolean;
  public Image: string;
  public Items: OrderItem[];
  public categoryPopupState: CategoryPopupState;
  constructor() {
    super();
    this.Title = "";
    this.Color = "";
    this.ApplyTax = false;
    this.ApplyService = false;
    this.categoryPopupState = CategoryPopupState.AllAvailable;
    this.PrintDisplayOrder = 0;
    this.ParentId = 0;
    this.Items = [];
  }
}
export class OrderItem extends EntityBase {
  public Title: string;
  public Code: number;
  public GoodsId?: number;
  public Title_En: string;
  public Description: string;
  public Description_En: string;
  public ApplyTax?: boolean;
  public ApplyService?: boolean;
  public Ingredients: string;
  public ItemTypeId: number;
  public ItemTypeTitle: string;
  public Ingredients_En: string;
  public CookingTime: number;
  public Calories: number;
  public CategoryId?: number;
  public MeasurementUnitId: number;
  public MeasurementUnitTitle: string;
  public TitleDisabled: boolean;
  public TaxApplyTypeId?: number;
  public TaxApplyTypeTitle: string;
  public TaxApplyTypeCode?: number;
  public ServiceApplyTypeId?: number;
  public ServiceApplyTypeTitle: string;
  public ServiceApplyTypeCode?: number;
  public StockInWeb?: StockInWebKind;
  public DetaultPrice: number;
  public Barcodes: ItemBarcode[];
  public Dependents: ItemDependency[];
  public Prices: ItemPrice[];
  public Branches: ItemBranch[];
  public ItemDescription: OrderDescription[];
  public ItemChild: OrderItem[];
  public ItemRelative: OrderItem[];
  public Additive: OrderAdditive[];
  public InvoiceQty: number;
  public IsDependent: boolean;
  public IsClubItem: boolean;
  public UnitKind?: number;
  public Tax: number;
  public Toll: number;
  public PackingPrice: number;
  public PrintDisplayOrder: number;
  public activeItem: boolean;
  public DataDaysWeekTitle: string | string[];
  public notAvailableGoodIds: number[];
  public favoriteIndex: number = -1;
  public OrganizationalDiscount = null;
  public IsOrganizationalDiscount = false;
  constructor() {
    super();
    this.favoriteIndex = -1;
    this.activeItem = false;
    this.Barcodes = [];
    this.Dependents = [];
    this.Prices = [];
    this.Branches = [];
    this.Additive = [];
    this.ItemChild = [];
    this.ItemDescription = [];
    this.IsDependent = false;
    this.Tax = 0;
    this.PrintDisplayOrder = 0;
    this.Toll = 0;
    this.PackingPrice = 0;
  }
}
export class OrderDescription extends EntityBase {
  public Id: number;
  public Title: string;
  public ItemId: string;
  public IsSelected: boolean;
}
export class OrderAdditive extends EntityBase {
  public Id: number;
  public Title: string;
  public ItemId: string;
  public Price: ItemPrice[];
  public Prices: ItemPrice[];
  public MainPrice: number;
  public SalePriceTypeId: number;
  public IsDefault: boolean;
  public IsSelected: boolean;
  public ApplyTax: boolean;
  public ApplyService: boolean;
  public Branches: number[];
}

export class ItemBarcode extends EntityBase {
  public Title: string;
  public Code: string;
}
export class ItemPrice extends EntityBase {
  public Price: number;
  public IsDefault: boolean;
  public SalePriceTypeId: number;
  public ItemId: number;
}
export class ItemBranch extends EntityBase {
  public BranchId: number;
  public IsActive: boolean;
  public BranchTitle: string;
  public Selected: boolean;
  public StockInWeb: StockInWebKind;
}
